
import {Location} from "@angular/common";
import {Router} from "@angular/router";
import {TranslationService} from "../translation/TranslationService";

export class NavigationService
{
    constructor(private translationService: TranslationService,
                private location:Location,
                private router:Router){

    }


    public Navigate(url:string){
        let currentLanguage = this.translationService.CurrentLanguage();

        this.router.url.endsWith("/" + currentLanguage) ?
            this.router.navigate([url + "/" + currentLanguage]) :
            this.router.navigate([url]);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/navigation/NavigationService.ts